
const Menu = ( ( window, undefined ) => {

  let windowWidth;
  const menu = document.getElementById('site-navigation'),
        burgerMenu = document.getElementById('burger-menu');

  const _calculateWidth = () => windowWidth = window.innerWidth;

  const _changeAriaAttribute = () => {
    const aria = burgerMenu.getAttribute("aria-expanded");
    let newAriaValue = (aria === 'true') ? false : true;
    burgerMenu.setAttribute("aria-expanded", newAriaValue);
  };

  const _toggleMobileMenu = () => {
    helpers.toggleClass(burgerMenu, 'is-open');
    helpers.toggleClass(menu, 'is-active');
    _changeAriaAttribute();
    return;
  };

  const _burgerEvent = () => {
    if ( windowWidth <= 768 ) 
      burgerMenu.addEventListener('click', _toggleMobileMenu )
    else
      burgerMenu.removeEventListener('click', _toggleMobileMenu );
    return;
  };

  const _initializeEvents = helpers.debounce( () => {
    _calculateWidth();
    _burgerEvent();
  }, 500);

  const init = () => {
    _initializeEvents();
    window.addEventListener( "resize", _initializeEvents )
  };

    return {
    init: init
  };

})( window );